<template lang="pug">
.searchBox.position-relative
  .searchBox__searchbox.d-flex.align-items-center.bg-white
    EcreativMoleculesSearchInputBox(
      :modelValue="query"
      @update:modelValue="val => query = val"
      @submit="onSearch"
    )

    EcreativMoleculesSearchTabSelectorDropdown.d-xl-none(
      :tabs="tabs"
      :selected="searchStore.selectedTabLabel"
      :open="isDropdownOpen"
      @update:selected="searchStore.updateSelectedTabLabel"
      @update:open="val => isDropdownOpen = val"
    )

    EcreativMoleculesSearchTabSelectorHorizontal.d-none.d-xl-flex(
      :tabs="tabs"
      :selected="searchStore.selectedTabLabel"
      @update:selected="searchStore.updateSelectedTabLabel"
    )
  .page__results-count.mt-3(v-if="showResultsCount")
    p.text-muted.m-0 {{ searchStore.resultsList.length }} results found
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useSearchStore, searchTypeToLabel, SearchType } from '#imports';

const route = useRoute();
const router = useRouter();
const searchStore = useSearchStore();

// These vars are used in template via v-model and bindings
const tabs = ['All', 'Videos', 'Articles'];

const query = ref(route.query.q ?? '');
const isDropdownOpen = ref(false);

searchStore.updateSelectedTabLabel(
  searchTypeToLabel(route.query.type as SearchType),
);

const isLoading = computed(() => searchStore.loadingStatus);

const showResultsCount = computed(() => {
  return (
    route.path === '/search-results' &&
    !isLoading.value &&
    searchStore.resultsList.length > 0
  );
});

function onSearch() {
  const term = query.value.trim();
  if (!term) return;

  const nextType = searchStore.type;

  router.push({ path: '/search-results', query: { q: term, type: nextType } });

  if (searchStore.shouldSearch(term, nextType)) {
    searchStore.search(term, nextType);
  }
}

watch(
  () => searchStore.selectedTabLabel,
  () => {
    const term = query.value.trim();
    if (!term) return;

    const nextType = searchStore.type;

    router.push({
      path: '/search-results',
      query: { q: term, type: nextType },
    });

    if (searchStore.shouldSearch(term, nextType)) {
      searchStore.search(term, nextType);
    }
  },
);

watch(
  () => route.query.q,
  (newQ) => {
    query.value = newQ ?? '';
  },
);

watch(
  () => route.query.type,
  (newType) => {
    searchStore.updateSelectedTabLabel(
      searchTypeToLabel(newType as SearchType),
    );
  },
);
</script>

<style scoped lang="scss">
.searchBox__searchbox {
  flex-wrap: nowrap;
  border: 1px solid #ccc;
  border-radius: 55px;
}
</style>
